import viewService from "@/services/viewService";
import EntityService from "@/services/entityService";

const projectService = new EntityService("Project");

const isPossivelId = (valor) => {
  if (!valor) return false;
  const texto = String(valor).trim();
  return /^[0-9a-f]{24}$/i.test(texto) || /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(texto);
};

const normalizarTexto = (valor) => String(valor || "").trim();

const extrairLista = (response) => {
  const lista = response?.data?.data?.data;
  if (Array.isArray(lista)) return lista;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

const possuiDadosValidos = (response) => {
  if (!response) return false;
  if (response?.success === false) return false;
  if (response?.data?.success === false) return false;
  return Array.isArray(response?.data?.data?.data) || Array.isArray(response?.data?.data) || Array.isArray(response?.data);
};

const obterJob = (linha = {}) => {
  const jobDireto = Array.isArray(linha?.job) ? linha.job[0] : linha?.job;
  if (jobDireto && typeof jobDireto === "object") return jobDireto;

  const projectDireto = Array.isArray(linha?.project) ? linha.project[0] : linha?.project;
  if (projectDireto && typeof projectDireto === "object") return projectDireto;

  return null;
};

const normalizarLinha = (linha = {}) => {
  const job = obterJob(linha);
  const contatoComercial = Array.isArray(job?.contatoComercial)
    ? job.contatoComercial[0] || {}
    : (job?.contatoComercial || {});
  const cliente = Array.isArray(job?.cliente) ? job.cliente[0] || {} : (job?.cliente || {});

  return {
    _id: linha?._id || linha?.id || `${linha?.codigo || linha?.code || "os"}-${Math.random()}`,
    osId: linha?._id || linha?.id || null,
    codigo: linha?.codigo || linha?.code || linha?.osCodigo || "-",
    descricao: linha?.descricao || "-",
    coordenador: linha?.coordenadorDeProjetosNome || "-",
    orcamento: job?.solicitacaoDeOrcamentoCodigo || job?.numeroProposta || job?.salesOrderCode || "-",
    cliente: job?.clienteNome || cliente?.nomeFantasia || cliente?.razaoSocial || "-",
    job: job?.code || job?.codigo || job?.jobCode || "-",
    contato: contatoComercial?.nome || contatoComercial?.celular || "-",
    fone: contatoComercial?.telefone || contatoComercial?.celular || "-",
    dataSolicitacao: linha?.dataSolicitacao || linha?.createdAt || null,
    dataFabricacaoPrevista: linha?.dataFabricacaoPrevista || null,
    prazo: linha?.dataEncerramentoPrevista || linha?.prazo || linha?.dataPrevisao || null,
    vendedor: cliente?.vendedorNome || cliente?.verndedorNome || job?.vendedorNome || "-",
    jobIdRaw: linha?.job || linha?.project || linha?.jobId || linha?.projectId || null,
    _rawLinha: linha
  };
};

const OS_VIEW_ID = "a3da9222-d1c8-480e-85e2-1e25763d0922";

const listarPorView = async (params = []) => {
  // Usa viewId diretamente (viewName não cadastrado no banco)
  try {
    const response = await viewService.viewRunById(OS_VIEW_ID, 1, params);
    if (possuiDadosValidos(response)) {
      return extrairLista(response);
    }
  } catch (_) { /* fallback para entidade */ }

  return [];
};

const listarPorEntidade = async () => {
  const candidatos = ["OrderService", "OrdemDeServico", "OS"];

  for (const schema of candidatos) {
    try {
      const service = new EntityService(schema);
      const response = await service.getAll(1, 5000, "", "", null, null, null, "codigo");
      const lista = extrairLista(response);
      if (Array.isArray(lista) && lista.length) {
        return lista;
      }
    } catch (_) {
      // tenta próximo schema
    }
  }

  return [];
};

const enriquecerJobs = async (lista = []) => {
  const ids = [
    ...new Set(
      (Array.isArray(lista) ? lista : [])
        .map((item) => {
          if (!item?.jobIdRaw) return "";
          if (typeof item.jobIdRaw === "string") return item.jobIdRaw;
          if (Array.isArray(item.jobIdRaw)) return String(item.jobIdRaw[0] || "");
          return String(item.jobIdRaw);
        })
        .filter((id) => isPossivelId(id))
    )
  ];

  if (!ids.length) return lista;

  let mapa = {};

  try {
    const response = await projectService.getAll(1, Math.max(100, ids.length), "", "", ids, null, null, null);
    const jobs = extrairLista(response);
    mapa = (Array.isArray(jobs) ? jobs : []).reduce((acc, job) => {
      const id = String(job?.id || job?._id || "");
      if (!id) return acc;
      acc[id] = job;
      return acc;
    }, {});
  } catch (_) {
    mapa = {};
  }

  return lista.map((item) => {
    let id = "";
    if (typeof item?.jobIdRaw === "string") id = item.jobIdRaw;
    else if (Array.isArray(item?.jobIdRaw)) id = String(item.jobIdRaw[0] || "");
    else id = String(item?.jobIdRaw || "");

    const job = mapa[id];
    if (!job) return item;

    const contatoComercial = Array.isArray(job?.contatoComercial)
      ? job.contatoComercial[0] || {}
      : (job?.contatoComercial || {});
    const cliente = Array.isArray(job?.cliente) ? job.cliente[0] || {} : (job?.cliente || {});

    return {
      ...item,
      orcamento: item.orcamento !== "-" ? item.orcamento : (job?.solicitacaoDeOrcamentoCodigo || job?.numeroProposta || "-"),
      cliente: item.cliente !== "-" ? item.cliente : (job?.clienteNome || cliente?.nomeFantasia || cliente?.razaoSocial || "-"),
      job: item.job !== "-" ? item.job : (job?.code || "-"),
      contato: item.contato !== "-" ? item.contato : (contatoComercial?.nome || contatoComercial?.celular || "-"),
      fone: item.fone !== "-" ? item.fone : (contatoComercial?.telefone || contatoComercial?.celular || "-"),
      vendedor: item.vendedor !== "-" ? item.vendedor : (cliente?.vendedorNome || cliente?.verndedorNome || "-")
    };
  });
};

const filtrarLista = (lista = [], filtros = {}) => {
  const inicio = filtros?.dataInicio ? new Date(filtros.dataInicio) : null;
  const fim = filtros?.dataFim ? new Date(filtros.dataFim) : null;
  const codigoFiltro = normalizarTexto(filtros?.codigo).toLowerCase();
  const jobFiltro = normalizarTexto(filtros?.job).toLowerCase();
  const clienteFiltro = normalizarTexto(filtros?.cliente).toLowerCase();
  const coordenadorFiltro = normalizarTexto(filtros?.coordenador).toLowerCase();
  const descricaoFiltro = normalizarTexto(filtros?.descricao).toLowerCase();

  return lista.filter((item) => {
    const dataLinha = item?.dataSolicitacao ? new Date(item.dataSolicitacao) : null;
    const dataInicioOk = !inicio || !dataLinha || Number.isNaN(dataLinha.getTime()) || dataLinha >= inicio;
    const dataFimOk = !fim || !dataLinha || Number.isNaN(dataLinha.getTime()) || dataLinha <= fim;

    const codigoOk = !codigoFiltro || normalizarTexto(item?.codigo).toLowerCase().includes(codigoFiltro);
    const jobOk = !jobFiltro || normalizarTexto(item?.job).toLowerCase().includes(jobFiltro);
    const clienteOk = !clienteFiltro || normalizarTexto(item?.cliente).toLowerCase().includes(clienteFiltro);
    const coordenadorOk = !coordenadorFiltro || normalizarTexto(item?.coordenador).toLowerCase().includes(coordenadorFiltro);
    const descricaoOk = !descricaoFiltro || normalizarTexto(item?.descricao).toLowerCase().includes(descricaoFiltro);

    return dataInicioOk && dataFimOk && codigoOk && jobOk && clienteOk && coordenadorOk && descricaoOk;
  });
};

export default {
  async listarRelatorioOS(filtros = {}) {
    const params = [
      {
        dataType: "String",
        name: "dataInicio",
        value: filtros?.dataInicio || "1970-01-01"
      },
      {
        dataType: "String",
        name: "dataFim",
        value: filtros?.dataFim || new Date().toISOString().slice(0, 10)
      },
      {
        dataType: "String",
        name: "codigo",
        value: filtros?.codigo || ""
      },
      {
        dataType: "String",
        name: "job",
        value: filtros?.job || ""
      }
    ];

    let lista = await listarPorView(params);

    if (!Array.isArray(lista) || !lista.length) {
      lista = await listarPorEntidade();
    }

    let normalizada = (Array.isArray(lista) ? lista : []).map((item) => normalizarLinha(item));
    normalizada = await enriquecerJobs(normalizada);

    return filtrarLista(normalizada, filtros);
  }
};
